import AboutList from './about-list';

export default class AboutListDesktop extends AboutList {
	constructor(...args) {
		super(...args);
	}

	_retrieveDOM() {
		super._retrieveDOM();

		this.dom.item = this.dom.page.querySelectorAll('.js-item');
	}

	bind() {
		super.bind();

		for (let i = 0; i < this.dom.item.length; i++) {
			const item = this.dom.item[i];
			const link = item.querySelector('.js-title-link');

			link.addEventListener('mouseover', this._addHover.bind(this, item));
			link.addEventListener('mouseout', this._removeHover.bind(this, item));
		}
	}

	// HELPERS
	_addHover(el) {
		el.classList.add('hover');
	}

	_removeHover(el) {
		el.classList.remove('hover');
	}

	/**
	 * init() {}
	 * bind() {}
	 * unbind() {}
	 * resize(width, height) {}
	 * _destroy() {}
	 */
}



// WEBPACK FOOTER //
// ./src/js/pages/about/list/about-list.desktop.js